<template>
  <div class="vcr-page__section vcr-signature">
    <h2 class="vcr-page__header">{{ i18n.t('/Vcr/Signature/Sign Label') }}</h2>

    <div class="vcr-signature__wrapper">
      <div class="vcr-signature__labels">
        <label>{{ i18n.t('/Vcr/Signature/Name Label') }}</label>
        <label>{{ i18n.t('/Vcr/Signature/Function Label') }}</label>
        <label>{{ i18n.t('/Vcr/Signature/Date Label') }}</label>
      </div>

      <div class="vcr-signature__signature">
        <label>{{ i18n.t('/Vcr/Signature/Signature Label') }}</label>
        <div class="vcr-signature__signature-box">&nbsp;</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
}
</script>

<style lang="scss" scoped>
.vcr-signature {
  &__wrapper {
    display: flex;
    flex-wrap: wrap;

    > div {
      flex-basis: 50%;
    }
  }

  &__labels > label {
    margin-bottom: var(--space-sm);
  }

  &__labels,
  &__signature {
    display: flex;
    flex-direction: column;

    > button {
      width: 4em;
    }

    &-box {
      height: 220px;
      border: 1px solid var(--color-border);
      margin-bottom: var(--space-sm);
    }
  }
}
</style>
